import React, { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const NavigationContext = createContext();

export const NavigationProvider = ({ children }) => {
  const navigate = useNavigate();
  const [path, setPath] = useState('');

  const redirect = (newPath) => {
    setPath(newPath);
    navigate(newPath);
  };

  return (
    <NavigationContext.Provider value={{ redirect, path }}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = () => useContext(NavigationContext);